import { z } from 'zod'

import { recordViewSchema, type RecordView, type RecordViewRequest } from '@/types/api/record-view'

import { apiClient } from './client'

export async function getRecordViews(recordGroupId: string): Promise<RecordView[]> {
  const response = await apiClient.get(`/record-groups/${recordGroupId}/views`)
  return z.array(recordViewSchema).parse(response.data)
}

export async function createRecordView(recordGroupId: string, data: RecordViewRequest): Promise<RecordView> {
  const response = await apiClient.post(`/record-groups/${recordGroupId}/views`, data)
  return recordViewSchema.parse(response.data)
}

export async function updateRecordView(viewId: string, data: RecordViewRequest): Promise<RecordView> {
  const response = await apiClient.put(`/record-views/${viewId}`, data)
  return recordViewSchema.parse(response.data)
}

export async function deleteRecordView(viewId: string): Promise<void> {
  await apiClient.delete(`/record-views/${viewId}`)
}

/** Set (viewId) or clear (null) the shared view a group opens by default. */
export async function setDefaultRecordView(recordGroupId: string, viewId: string | null): Promise<void> {
  await apiClient.put(`/record-groups/${recordGroupId}/default-view`, { viewId })
}
